var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// TEAM_UPDATE_SURVEYS
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation TeamUpdateSurveys(\n    $add_ids: [ID!]\n    $team_id: ID!\n    $remove_ids: [ID!]\n  ) {\n    teamUpdateSurveys(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"], ["\n  mutation TeamUpdateSurveys(\n    $add_ids: [ID!]\n    $team_id: ID!\n    $remove_ids: [ID!]\n  ) {\n    teamUpdateSurveys(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"])));
export default function useTeamUpdateSurveysMutation() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'teamUpdateSurveys',
        successMessage: 'Team surveys updated',
        refetchQueries: ['TeamSurveys']
    }), onMutate = _a.onMutate, loading = _a.loading;
    return { onMutate: onMutate, loading: loading };
}
var templateObject_1;
